import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SlowMotionVideoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"slow_motion_video"}/>
}
